const searchStrip = {
  hotels: "Viešbučiai", // translated 
  city: "Miestas", // translated 
  checkIn: "Įsiregistruoti", // translated 
  checkOut: "Išsiregistruokite", // translated 
  date: "Data", // translated 
  persons: "Asmenys", // translated 
  adults: "Suaugusieji", // translated 
  rooms: "Kambariai", // translated 
  editSearch: "Redaguoti paiešką", // translated 
  newSearch: "Nauja paieška", // translated 
  listView: "Sarašas", // translated 
  mapView: "Žemėlapio vaizdas", // translated 
};



export default searchStrip;
